import SpecimenStateMain from '../views/biobank/specimen_state/SpecimenStateMain.vue';
import SpecimenStateList from '../views/biobank/specimen_state/SpecimenStateList.vue';
import SpecimenStateCreate from '../views/biobank/specimen_state/SpecimenStateCreate.vue';
import SpecimenStateUpdate from '../views/biobank/specimen_state/SpecimenStateUpdate.vue';
import SpecimenStateView from '../views/biobank/specimen_state/SpecimenStateView.vue';

import SpecimenTypeMain from '../views/biobank/specimen_type/SpecimenTypeMain.vue';
import SpecimenTypeList from '../views/biobank/specimen_type/SpecimenTypeList.vue';
import SpecimenTypeCreate from '../views/biobank/specimen_type/SpecimenTypeCreate.vue';
import SpecimenTypeUpdate from '../views/biobank/specimen_type/SpecimenTypeUpdate.vue';
import SpecimenTypeView from '../views/biobank/specimen_type/SpecimenTypeView.vue';

import MethodOfCollectionMain from '../views/biobank/method_of_collection/MethodOfCollectionMain.vue';
import MethodOfCollectionList from '../views/biobank/method_of_collection/MethodOfCollectionList.vue';
import MethodOfCollectionCreate from '../views/biobank/method_of_collection/MethodOfCollectionCreate.vue';
import MethodOfCollectionUpdate from '../views/biobank/method_of_collection/MethodOfCollectionUpdate.vue';
import MethodOfCollectionView from '../views/biobank/method_of_collection/MethodOfCollectionView.vue';

import CaseMain from '../views/biobank/case/CaseMain.vue';
import CaseList from '../views/biobank/case/CaseList.vue';
import CaseCreate from '../views/biobank/case/CaseCreate.vue';
import CaseUpdate from '../views/biobank/case/CaseUpdate.vue';
import CaseView from '../views/biobank/case/CaseView.vue';

import SpecimenMain from '../views/biobank/specimen/SpecimenMain.vue';
import SpecimenList from '../views/biobank/specimen/SpecimenList.vue';
import SpecimenCreate from '../views/biobank/specimen/SpecimenCreate.vue';
import SpecimenUpdate from '../views/biobank/specimen/SpecimenUpdate.vue';
import SpecimenView from '../views/biobank/specimen/SpecimenView.vue';

import FreezerMain from '../views/biobank/freezer/FreezerMain.vue';
import FreezerList from '../views/biobank/freezer/FreezerList.vue';
import FreezerCreate from '../views/biobank/freezer/FreezerCreate.vue';
import FreezerUpdate from '../views/biobank/freezer/FreezerUpdate.vue';
import FreezerView from '../views/biobank/freezer/FreezerView.vue';

import SpecimenAdditionalInfoMain from '../views/biobank/specimen_additional_info/SpecimenAdditionalInfoMain.vue';
import SpecimenAdditionalInfoList from '../views/biobank/specimen_additional_info/SpecimenAdditionalInfoList.vue';
import SpecimenAdditionalInfoCreate from '../views/biobank/specimen_additional_info/SpecimenAdditionalInfoCreate.vue';
import SpecimenAdditionalInfoUpdate from '../views/biobank/specimen_additional_info/SpecimenAdditionalInfoUpdate.vue';
import SpecimenAdditionalInfoView from '../views/biobank/specimen_additional_info/SpecimenAdditionalInfoView.vue';

import BoxMain from '../views/biobank/box/BoxMain.vue';
import BoxList from '../views/biobank/box/BoxList.vue';
import BoxCreate from '../views/biobank/box/BoxCreate.vue';
import BoxUpdate from '../views/biobank/box/BoxUpdate.vue';
import BoxView from '../views/biobank/box/BoxView.vue';

export default {
  routes: [
    {
      path: 'specimen-state', // SpecimenStateList
      name: 'specimen-state',
      component: SpecimenStateMain,
      children: [
        {
          path: 'list',
          name: 'specimen-state.list',
          component: SpecimenStateList,
        },
        {
          path: 'create',
          name: 'specimen-state.create',
          component: SpecimenStateCreate,
        },
        {
          path: 'update/:id',
          name: 'specimen-state.edit',
          component: SpecimenStateUpdate,
        },
        {
          path: 'update/:id',
          name: 'specimen-state.view',
          component: SpecimenStateView,
        },
      ],
    },
    {
      path: 'specimen-type',
      name: 'specimen-type',
      component: SpecimenTypeMain,
      children: [
        {
          path: 'list',
          name: 'specimen-type.list',
          component: SpecimenTypeList,
        },
        {
          path: 'create',
          name: 'specimen-type.create',
          component: SpecimenTypeCreate,
        },
        {
          path: 'update/:id',
          name: 'specimen-type.edit',
          component: SpecimenTypeUpdate,
        },
        {
          path: 'update/:id',
          name: 'specimen-type.view',
          component: SpecimenTypeView,
        },
      ],
    },
    {
      path: 'method-of-collection',
      name: 'method-of-collection',
      component: MethodOfCollectionMain,
      children: [
        {
          path: 'list',
          name: 'method-of-collection.list',
          component: MethodOfCollectionList,
        },
        {
          path: 'create',
          name: 'method-of-collection.create',
          component: MethodOfCollectionCreate,
        },
        {
          path: 'edit',
          name: 'method-of-collection.edit',
          component: MethodOfCollectionUpdate,
        },
        {
          path: 'update/:id',
          name: 'method-of-collection.view',
          component: MethodOfCollectionView,
        },
      ],
    },
    {
      path: 'bcase',
      name: 'bcase',
      component: CaseMain,
      children: [
        {
          path: 'list',
          name: 'bcase.list',
          component: CaseList,
        },
        {
          path: 'create',
          name: 'bcase.create',
          component: CaseCreate,
        },
        {
          path: 'update/:id',
          name: 'bcase.edit',
          component: CaseUpdate,
        },
        {
          path: 'update/:id',
          name: 'bcase.view',
          component: CaseView,
        },
      ],
    },
    {
      path: 'specimen',
      name: 'specimen',
      component: SpecimenMain,
      children: [
        {
          path: 'list',
          name: 'specimen.list',
          component: SpecimenList,
        },
        {
          path: 'create',
          name: 'specimen.create',
          component: SpecimenCreate,
        },
        {
          path: 'update/:id',
          name: 'specimen.edit',
          component: SpecimenUpdate,
        },
        {
          path: 'update/:id',
          name: 'specimen.view',
          component: SpecimenView,
        },
      ],
    },
    {
      path: 'freezer',
      name: 'freezer',
      component: FreezerMain,
      children: [
        {
          path: 'list',
          name: 'freezer.list',
          component: FreezerList,
        },
        {
          path: 'create',
          name: 'freezer.create',
          component: FreezerCreate,
        },
        {
          path: 'update/:id',
          name: 'freezer.edit',
          component: FreezerUpdate,
        },
        {
          path: 'view/:id',
          name: 'freezer.view',
          component: FreezerView,
        },
      ],
    },
    {
      path: 'specimenAdditionalInfo',
      name: 'specimenAdditionalInfo',
      component: SpecimenAdditionalInfoMain,
      children: [
        {
          path: 'list',
          name: 'specimenAdditionalInfo.list',
          component: SpecimenAdditionalInfoList,
        },
        {
          path: 'create',
          name: 'specimenAdditionalInfo.create',
          component: SpecimenAdditionalInfoCreate,
        },
        {
          path: 'update/:id',
          name: 'specimenAdditionalInfo.edit',
          component: SpecimenAdditionalInfoUpdate,
        },
        {
          path: 'update/:id',
          name: 'specimenAdditionalInfo.view',
          component: SpecimenAdditionalInfoView,
        },
      ],
    },
    {
      path: 'box', // SpecimenStateList
      name: 'box',
      component: BoxMain,
      children: [
        {
          path: 'list',
          name: 'box.list',
          component: BoxList,
        },
        {
          path: 'create',
          name: 'box.create',
          component: BoxCreate,
        },
        {
          path: 'update/:id',
          name: 'box.edit',
          component: BoxUpdate,
        },
        {
          path: 'update/:id',
          name: 'box.view',
          component: BoxView,
        },
      ],
    },
  ],
};
